import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import { isInternalUser, isPermissionError, isSSRError } from '../components/analyticsUtils.ts';
import type { useAnalyticsByLineQuery$data as GraphqlQueryData } from '../components/AnalyticsByLine/__generated__/useAnalyticsByLineQuery.graphql.ts';

export const useHideByline = (
	loading: boolean,
	data?: GraphqlQueryData,
	error?: ApolloErrorInterop,
): boolean => {
	return loading || isSSRError(data, error) || isPermissionError(error) || !isInternalUser(data);
};
